var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"post-crossprom-dashboard",attrs:{"type":"cpInfo"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.seeCpInfo.apply(null, arguments)}}},[_vm._v("\n    Preview Update\n")])}
var staticRenderFns = []

export { render, staticRenderFns }